define([], () => ({
  UPDATE_SHORTCUT_GLOBALS: 'UPDATE_SHORTCUT_GLOBALS',

  REQUEST_SHORTCUT_TEMPLATES: 'REQUEST_SHORTCUT_TEMPLATES',
  RECEIVE_SHORTCUT_TEMPLATES: 'RECEIVE_SHORTCUT_TEMPLATES',
  ERROR_SHORTCUT_TEMPLATES: 'ERROR_SHORTCUT_TEMPLATES',
  RECEIVE_SHORTCUT: 'RECEIVE_SHORTCUT',
  RECEIVE_SHORTCUTS: 'RECEIVE_SHORTCUTS',

  UPDATE_SHORTCUT: 'UPDATE_SHORTCUT',
  UPDATE_SHORTCUT_SETTING: 'UPDATE_SHORTCUT_SETTING',
  UPDATE_SHORTCUT_SETTINGS: 'UPDATE_SHORTCUT_SETTINGS',
  UPDATE_SHORTCUT_DEFINITION: 'UPDATE_SHORTCUT_DEFINITION',
  UPDATE_SHORTCUT_EMAIL_CAMPAIGN: 'UPDATE_SHORTCUT_EMAIL_CAMPAIGN',
  UPDATE_SHORTCUT_DISCOUNT: 'UPDATE_SHORTCUT_DISCOUNT',
  UPDATE_SHORTCUT_FORM: 'UPDATE_SHORTCUT_FORM',

  REQUEST_SHORTCUT_TEMPLATE: 'REQUEST_SHORTCUT_TEMPLATE',
  RECEIVE_SHORTCUT_TEMPLATE: 'RECEIVE_SHORTCUT_TEMPLATE',
  ERROR_SHORTCUT_TEMPLATE: 'ERROR_SHORTCUT_TEMPLATE',

  UPDATE_SHORTCUT_FORM_COMPONENT: 'UPDATE_SHORTCUT_FORM_COMPONENT',
  UPDATE_SHORTCUT_EMAIL_FIELD: 'UPDATE_SHORTCUT_EMAIL_FIELD',
  UPDATE_SHORTCUT_EMAIL_VARIABLE: 'UPDATE_SHORTCUT_EMAIL_VARIABLE',
  UPDATE_EMAIL_NODES: 'UPDATE_EMAIL_NODES',
  UPDATE_CURRENT_STEP_TO: 'UPDATE_CURRENT_STEP_TO',
  SET_SHORTCUT_CURRENT: 'SET_SHORTCUT_CURRENT',

  ADD_DISPLAY_RULE: 'ADD_DISPLAY_RULE',
  REMOVE_DISPLAY_RULE: 'REMOVE_DISPLAY_RULE',
  LOAD_DISPLAY_RULES: 'LOAD_DISPLAY_RULES',
  RECEIVE_SHORTCUT_SETTINGS: 'RECEIVE_SHORTCUT_SETTINGS',

  SET_SELECTED_PRODUCT: 'SET_SELECTED_PRODUCT',

  UPDATE_SHORTCUT_COLOR: 'UPDATE_SHORTCUT_COLOR',

  RECEIVE_DISCOUNT_SETTINGS: 'RECEIVE_DISCOUNT_SETTINGS',

  VALIDATE_SHORTCUT: 'VALIDATE_SHORTCUT',

  RECEIVE_EMAIL_TEMPLATE: 'RECEIVE_EMAIL_TEMPLATE',

  RECEIVE_EMAIL_MERGE_DATA: 'RECEIVE_EMAIL_MERGE_DATA',
}));
